import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    auth_type: "login",
    auth_modal: false,
    logincreds: null
  };
  
  const authStateSlice = createSlice({
    name: 'auth',
    initialState: initialState,
    reducers: {
      setAuthType: (state, action) => {
        state.auth_type= action.payload 
      },
     
      setAuthModal: (state, action) => {
     
       state.auth_modal = action.payload
      },

      storeLoginCredentials: (state, action) => {
        state.logincreds = action.payload
      },

      removeLoginCredentials: (state) => {
        state.logincreds = null
      }
    }
  });
  
  export const { setAuthModal, setAuthType, storeLoginCredentials, removeLoginCredentials } = authStateSlice.actions;
  
  export default authStateSlice.reducer;